<template>
<v-menu offset-y>
  <v-btn slot="activator" flat style="min-width:24px;">
    <div><v-icon small>translate</v-icon><br><span>{{ $t('lang.' + $i18n.locale) }}</span></div>
  </v-btn>
  <v-list>
    <v-list-tile v-for="(item, index) in localeList" :key="index" @click="setLanguage(item)">
      <v-list-tile-title>{{ $t('lang.' + item) }}</v-list-tile-title>
    </v-list-tile>
  </v-list>
</v-menu>
</template>

<script>
export default {
  name: 'LanguageMenu',
  methods: {
    setLanguage(lang) {
      this.$i18n.locale = lang;
      this.$cookie.set('lang', lang);
    }
  },
  computed: {
    currentLocale() {
      return this.$t('lang.' + this.$i18n.locale);
    },
    localeList() {
      return Object.keys(this.$i18n.messages).filter(key => key != this.$i18n.locale);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/LanguageMenu.vue